import {
	mixinsData
} from './MixinsData';
import {
	mixinsFunc
} from './MixinsFunc';
import {
	mixinsComponents
} from './MixinsComponents';

const CommonMixins = {
	components: {
		...mixinsComponents
	},
	data() {
		return mixinsData
	},
	methods: mixinsFunc
}
export {
	CommonMixins
}
